import React from 'react';
import { observer } from 'mobx-react';
import { getTeamsLite } from 'areas/administration/teams/api';
import { useRemoteListForSelect } from 'framework/api';
import { AntSelect } from './ant/ant-select/antSelect';
import { AntSelectPropsGeneric, fieldNamesIdName } from './ant/ant-select/types';

export type TeamSelectorProps = AntSelectPropsGeneric<string[]> & {
	accountId?: string;
	multiple?: boolean;
};

export const TeamSelector = observer(({ accountId, multiple, ...rest }: TeamSelectorProps) => {
	const remoteData = useRemoteListForSelect(getTeamsLite(accountId));

	return (
		<AntSelect
			mode={multiple ? 'multiple' : undefined}
			allowClear={multiple}
			sortValues={true}
			showSearch={{ optionFilterProp: 'label' }}
			fieldNames={fieldNamesIdName}
			{...remoteData}
			{...rest}
		/>
	);
});
